<template>
  <v-app>
    <div>
      <div class="text-h6 mt-6">
          <v-icon large>mdi-calendar</v-icon>นัดหมายวันนี้
      </div>
      <div v-if="appointmentlist.length==0" class="text-h5 mt-16">
        คุณไม่มีนัดหมายวันนี้
      </div>
      <v-list
      class="mt-8">
        <v-list-item
          class="ma-3"
          align="left"
          v-for="(item) in appointmentlist"
          :key="item.reservation_id"
          style="border: 4px solid #D7FF66;"
        >
          <v-list-item-content>
            <v-btn class="mb-2" color="primary" @click="activate(item.reservation_id)">{{ new Date()>new Date(item.reservation_dateend) ? 'แจ้งมาช้าเกินกำหนด' : 'แจ้งก่อนกำหนด' }}</v-btn>
            <v-list-item-title>{{ item.group_name }}</v-list-item-title>
            <v-list-item-subtitle>
                {{ item.reservation_date }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
                {{ item.reservation_timestart + ' - ' +  item.reservation_timeend}}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </v-app>
</template>


<style>
html {
    height: 100%;
}
body {
    height: 100%;
}
#app {
    height: 100%;
}
</style>

<script>

import axios from 'axios';
import config from '@/../config.js'
import App from '@/models/instance/App'
import Member from '@/models/instance/Member'
import liff from '@line/liff';

export default {
  data () {
    return {
        appointmentlist : [],
    }
  },
  computed: {
  },
  mounted : function () {
    var que = this.$store.commit('addLoading')
    axios
    .post(config.api.url.public.line.get_liff,{app_id:App.getAppId()})
    .then(response_liff => {
      liff.init({ liffId: response_liff.data.liff.replace('https://liff.line.me/','')})
      .then(() => {
        const idToken = liff.getDecodedIDToken();
        idToken['app_id'] = App.getAppId()
        if(idToken != null){
          axios.post(config.api.url.public.line.login,idToken)
          .then(response => {
              this.$store.commit('finishLoading',que)
              if(!response.data.friendFlag){
                location.replace(App.getAppConfigAddFriendUrl())
              }else if(response.data.isSuccess){
                Member.setToken(response.data.token)
                if(response.data.is_firsttime){
                  axios.post(config.api.url.public.line.register,{ lang : 'th' , app_id:App.getAppId() },{ headers: Member.getTokenHeader()})
                  .then(response2=>{
                    Member.setToken(response2.data.token)
                    Member.setLang(response2.data.lang)
                    this.mounted_2()
                  })
                }else{
                  Member.setLang(response.data.lang)
                  this.mounted_2()
                }
              }else{
                this.$router.push({name:'Error',params:response.data}) 
              }
          })
        }else{
          //this.$store.commit('finishLoading',que)
          this.mounted_2()
        }
      });
    })
  },
  methods : {
    mounted_2(){
      var que = this.$store.commit('addLoading')
      axios
      .post(config.api.url.public.station.get_stationshortdetail,{station_code:this.$route.params.station_code})
      .then(response1 => {
        axios
        .post(config.api.url.line.station.get_stationmemberstatus
          ,{ station_code:this.$route.params.station_code}
          ,{ headers: Member.getTokenHeader()})
        .then(response2 => {

          var isnext = false

          if(response2.data.is_stationmember){
            isnext = true
          }else{
            if(response1.data.user_register_mode=="guest"){
              isnext = true
            }else{
              this.$store.commit('finishLoading',que)
              this.$router.replace({name:'RegisterForm',params:{station_code:this.$route.params.station_code}})
            }
          }

          if(isnext){
            axios
            .post(config.api.url.line.appointment.get_activatelist
                ,{ app_id: App.getAppId() , station_code:this.$route.params.station_code}
                ,{ headers: Member.getTokenHeader()})
            .then(response => {
                this.$store.commit('finishLoading',que)
                console.log(response.data)
                this.appointmentlist = response.data
                this.appointmentlist.forEach((r,i,arr)=>{
                  r.reservation_timestart = '0000' + r.reservation_timestart;
                  r.reservation_timestart = r.reservation_timestart.substring(r.reservation_timestart.length-4,r.reservation_timestart.length);
                  arr[i]['reservation_timestart']  = r.reservation_timestart.substring(0,2) + ":" + r.reservation_timestart.substring(2,4);
                  r.reservation_timeend = '0000' + r.reservation_timeend;
                  r.reservation_timeend = r.reservation_timeend.substring(r.reservation_timeend.length-4,r.reservation_timeend.length);
                  arr[i]['reservation_timeend']  =  r.reservation_timeend.substring(0,2) + ":" + r.reservation_timeend.substring(2,4);
                })
                if(response.data.length == 1){
                    console.log(response.data[0])
                    if(new Date()>=new Date(response.data[0].reservation_datestart) && new Date()<=new Date(response.data[0].reservation_dateend)){
                        this.activate(response.data[0].reservation_id)

                    }
                }
            })
          }
        })
      })
    },
    activate(reservation_id){
        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.line.appointment.activate
        ,{ 
            app_id:App.getAppId()
            ,station_code:this.$route.params.station_code
            ,reservation_id:reservation_id
        }
        ,{ headers: Member.getTokenHeader()})
        .then(() => {
            this.$store.commit('finishLoading',que)
            this.$router.push({name:"Success",params: { 
                success_text_1:  this.$t('success_activate_1')
                ,success_text_2:  this.$t('success_activate_2')
            }})
        })
    }
  },
}
</script>